import RequestSummary from "../request-summary/RequestSummary";
import IndividualKitchenDesign from "../request/IndividualKitchenDesign";
import IndividualKitchenDesignReview from "../request/IndividualKitchenDesignReview";
import DisplayMasters from "../request/MasterData";
import RequestList from "../request/RequestList";
import RequestReview from "../request/RequestReview";
import RequestSuccess from "../request/RequestSuccess";
import ShowroomQuestionnaire from "../request/ShowroomQuestionnaire";
import SpacePlaning from "../request/SpacePlaning";
import SpacePlaningReview from "../request/SpacePlaningReview";
import Dashboard from "./Dashboard";

const DashboardConfig = {
    settings: {
        layout: {
            config: {},
        },
    },
    routes: [
        {
            path: '/design-studio/dashboard',
            element: <Dashboard />,
        },
        {
            path: '/design-studio/request-list',
            element: <RequestList />,
        },
        {
            path: '/design-studio/showroom-questionnaire/:id',
            element: <ShowroomQuestionnaire />,
        },
        {
            path: '/design-studio/request-review/:id',
            element: <RequestReview />,
        },
        {
            path: '/design-studio/space-planing/:id',
            element: <SpacePlaning />,
        },
        {
            path: '/design-studio/space-planing-review/:id',
            element: <SpacePlaningReview />,
        },
        {
            path: '/design-studio/individual-kitchen-design/:id',
            element: <IndividualKitchenDesign />,
        },
        {
            path: '/design-studio/individual-kitchen-design-review/:id',
            element: <IndividualKitchenDesignReview />,
        },
        {
            path: '/design-studio/display-master',
            element: <DisplayMasters />,
        },
        {
            path: '/design-studio/success',
            element: <RequestSuccess />
        },
        {
            path: '/design-studio/request-summary/:id',
            element: <RequestSummary />
        }
    ],
};

export default DashboardConfig;
